module.exports = __webpack_public_path__ + "img/formsDreieckGSE.bf09da45.svg";